import React, { InputHTMLAttributes, forwardRef } from 'react';
import './styles.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
  autocomplete?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, fullWidth = true, className = '', autocomplete, ...rest }, ref) => {
    return (
      <div className={`input-container ${fullWidth ? 'full-width' : ''} ${className}`}>
        {label && <label className="input-label">{label}</label>}
        <input
          ref={ref}
          className={`input-field ${error ? 'has-error' : ''}`}
          autoComplete={autocomplete}
          {...rest}
        />
        {error && <span className="input-error">{error}</span>}
      </div>
    );
  }
);

export default Input;